import { createSlider } from '@typeform/embed'
import '@typeform/embed/build/css/slider.css'

import store from '@/store'
import GiftsApi from '@/lib/api/Gifts'

let interval = null
const type = 'lista_presentes_feedback'

const getIsViewed = () => {
  const giftsApi = new GiftsApi(store.state.app.logonToken)
  return giftsApi
    .getGiftsUserSurveysByType(type)
    .then((surveys) => {
      if (surveys.length) return true
      return false
    })
    .catch(() => false)
}

const saveSurvey = () => {
  const giftsApi = new GiftsApi(store.state.app.logonToken)
  giftsApi.saveGiftsListsSurvey({
    tipo: type,
    resposta: 'visualizado',
  })
}

const openTypeformGiftListFeedback = () => {
  const wedSiteInfo = store.state.app.wedSiteInfo
  const wedId = store.state.app.logonToken.token_payload.wed_id

  createSlider('h06BzmsZ', {
    hideHeaders: true,
    hideFooter: true,
    autoClose: 120000,
    hidden: {
      wed_id: wedId,
      noivo1: wedSiteInfo.noivo1_nome,
      noivo2: wedSiteInfo.noivo2_nome,
      fone1: wedSiteInfo.contato_fone1,
      fone2: wedSiteInfo.contato_fone2,
      email: wedSiteInfo.site_email,
    },
  }).open()

  saveSurvey()

  if (interval != null) {
    clearInterval(interval)
  }
}

const startIntervalTypeformGiftListFeedback = () => {
  interval = setInterval(() => {
    if (!store.state.gifts.isEditing) {
      openTypeformGiftListFeedback()
    }
  }, 2000)
}

export default () => {
  setTimeout(async () => {
    const isViewed = await getIsViewed()
    if (isViewed) return false

    if (!store.state.gifts.isEditing) {
      openTypeformGiftListFeedback()
    } else {
      startIntervalTypeformGiftListFeedback()
    }
  }, 480000)
}
